import * as firebase from 'firebase/app';
import 'firebase/analytics';

const analyticsModule = {
  active: async () => {
    try {
      if (firebase.apps.length !== 0) {
        await firebase.analytics();
        return true;
      }
    } catch (e) {
      console.debug('Firebase Analytics not initialized', e);
    }

    return false;
  },

  signup: async (id) => {
    if (await analyticsModule.active()) {
      firebase.analytics().logEvent('user_signup');
    }
  },

  login: async (id) => {
    if (await analyticsModule.active()) {
      firebase.analytics().logEvent('user_login');
    }
  },

  recoveryBegin: async (id) => {
    if (await analyticsModule.active()) {
      firebase.analytics().logEvent('user_recovery_begin');
    }
  },

  view: async (location) => {
    if (await analyticsModule.active()) {
      if (!!location) {
        location = window.location.pathname;
      }

      firebase.analytics().setCurrentScreen(location);
      firebase.analytics().logEvent('screen_view');
    }
  },

  viewProduct: async (product) => {
    const params3 = {
      currency: 'EUR',
      value: product.prezzo,
      items: [
        {
          item_id: product.codice_ministeriale,
          item_name: product.nome_prodotto,
          item_category: product.categoria1,
          item_variant: product.categoria2,
          item_brand: product.descrizione_ditta_1_produttrice,
          price: product.prezzo,
        },
      ],
    };

    if (await analyticsModule.active()) {
      firebase.analytics().logEvent(firebase.analytics.EventName.VIEW_ITEM, params3);
    }
  },

  addToCart: async (product) => {
    const params3 = {
      currency: 'EUR',
      value: product.price * product.quantity,
      items: [
        {
          item_id: product.code,
          item_name: product.nome_prodotto,
          item_category: product.categoria1,
          item_variant: product.categoria2,
          item_brand: product.descrizione_ditta_1_produttrice,
          price: product.amount,
          quantity: product.quantity,
        },
      ],
    };

    if (await analyticsModule.active()) {
      firebase.analytics().logEvent(firebase.analytics.EventName.ADD_TO_CART, params3);
    }
  },

  purchase: async (order, products) => {
    let items = products.map((product) => ({
      item_id: product.code,
      item_name: product.nome_prodotto,
      item_category: product.categoria1,
      item_variant: product.categoria2,
      item_brand: product.descrizione_ditta_1_produttrice,
      price: product.amount,
      quantity: product.quantity,
    }));

    const params10 = {
      transaction_id: order.id,
      currency: 'EUR',
      value: order.total,
      items: items,
    };

    if (await analyticsModule.active()) {
      firebase.analytics().logEvent(firebase.analytics.EventName.PURCHASE, params10);
    }
  },
};

export default analyticsModule;
